import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './itemConfigurations.html'

/**
 * Item Configuration route
 *
 * @namespace routes.AdminItemConfigurations
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.settings.itemConfigurations.list',
  label: 'ADMIN.ITEMCONFIGURATIONS.TITLE',
  url: '/items',
  component: 'tmrAdminItemConfigurations',
  resourceType: 'ItemConfiguration',
  resourceList: {
    searchParameters: ['code', 'description'],
  },
}

/**
 * Component for {@link routes.tmrAdminItemConfigurations Item Configuration route}
 *
 * @type {ngComponent}
 */
export const tmrAdminItemConfigurations = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminItemConfigurationsController',
  bindings: resourceListBindings(),
}

/**
 * @type {ngController}
 */
export class tmrAdminItemConfigurationsController {
  static ngType = 'controller'

  constructor(tmrIdentifierTypes) {
    'ngInject'
    Object.assign(this, { tmrIdentifierTypes })
  }
}
